export type TokenSupplyStatusType = {
  label: string;
  chartData: {
    color: string;
    percent: string;
    width: string;
  };
  shuffle: string;
};

export const tokenSupplyStatusList = [
  {
    label: 'Total Amount Of Issue',
    chartData: {
      color: '#3A7FFF',
      percent: '100%',
      width: '100%',
    },
    shuffle: '10,000,000,000',
  },
  {
    label: 'Total Supply',
    chartData: {
      color: '#64CFF6',
      percent: '100%',
      width: '100%',
    },
    shuffle: '10,000,000,000',
  },
  {
    label: 'Circulation Volume',
    chartData: {
      color: '#CDB5FF',
      percent: '11.4%',
      width: '11.4%',
    },
    shuffle: '1,140,000,000',
  },
  {
    label: 'The Amount Of Not Distributed',
    chartData: {
      color: '#FF7CFF',
      percent: '53.0%',
      width: '53.0%',
    },
    shuffle: '5,297,580,953',
  },
];

export const triTokenSupplyStatusList = [
  {
    label: 'Total Amount Of Issue',
    chartData: {
      color: '#3A7FFF',
      percent: '100%',
      width: '100%',
    },
    shuffle: '100,000,000',
  },
  {
    label: 'Total Supply',
    chartData: {
      color: '#64CFF6',
      percent: '100%',
      width: '100%',
    },
    shuffle: '100,000,000',
  },
];
